import pino from 'pino';

const Logger = pino({
    level: 'trace',
});

export default Logger;
